import React from 'react';
import { observer } from 'mobx-react';

import { classes } from '~utils/ClassNames';
import { getDiscountsData } from '~api/utils/skuDiscounts';

import PriceItem from './PriceItem/PriceItem';
import TotalPriceItem from './TotalPriceItem/TotalPriceItem';
import { ICartItemPriceWrapper } from './ICartItemPriceWrapper';
import { Container, PriceContainer } from './CartItemPriceWrapperStyles';

const priceClass = classes('cart-item-price');

const CartItemPriceWrapper: React.FC<ICartItemPriceWrapper> = observer(
    ({ cartItem, className }) => {
        const priceWrapperClass = classes('cart-item-price-wrapper', className);

        const {
            unitPriceWithTax: originalPrice,
            appliedPriceWithTax: discountedTotalPrice,
            discountPercent: productDiscount,
            product: { price: productPrice },
            appliedPrice: totalPrice,
            hasMarkdownDiscount,
            isDonationItem,
            isFreeVirtualSkuItem,
            isWpOffer,
            basePrice = originalPrice,
            discountedUnitPrice,
            isLoyaltyReward,
            itemLoyaltyPoints
        } = cartItem;

        const { freeItem, freeSample, showDiscountedTotal } = getDiscountsData(cartItem);
        const discountedClassName = showDiscountedTotal ? classes('cart-item-discounted') : '';

        return (
            <Container className={priceClass}>
                <PriceContainer className={`${priceWrapperClass} ${discountedClassName}`}>
                    {(productPrice || productPrice === 0) && (
                        <PriceItem
                            originalPrice={basePrice}
                            discountedPrice={discountedUnitPrice}
                            productDiscount={productDiscount}
                            showDiscountedTotal={showDiscountedTotal}
                            hasMarkDownPrice={hasMarkdownDiscount}
                            isDonationItem={isDonationItem}
                            isFreeVirtualSkuItem={isFreeVirtualSkuItem}
                            isLoyaltyReward={isLoyaltyReward}
                            freeItem={freeItem}
                            freeSample={freeSample}
                            isWpOffer={isWpOffer}
                        />
                    )}
                    <TotalPriceItem
                        skuId={cartItem.skuId}
                        freeItem={freeItem}
                        freeSample={freeSample}
                        originalPrice={totalPrice}
                        showDiscountedTotal={showDiscountedTotal}
                        discountedPrice={discountedTotalPrice}
                        isWpOffer={isWpOffer}
                        isLoyaltyReward={isLoyaltyReward}
                        itemLoyaltyPoints={itemLoyaltyPoints}
                    />
                </PriceContainer>
            </Container>
        );
    }
);

export default CartItemPriceWrapper;
